import moment from "moment"

export const normalizeISODateStringWithTimezoneOffset = (
  dateString: string,
) => {
  if (!dateString) return dateString

  return moment(dateString).toISOString(true)
}
